import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/feature/access/feature.access.lockImpact.query.gql"
import type {
  FeatureLockImpactQuery,
  FeatureLockImpactQueryVariables,
} from "@/v2-backoffice-client/feature/access/__types__/feature.access.lockImpact.query"

type Options = QueryHookOptions<
  FeatureLockImpactQuery,
  FeatureLockImpactQueryVariables
>

export function useFeatureLockImpactQuery(options?: Options) {
  return useQuery<FeatureLockImpactQuery, FeatureLockImpactQueryVariables>(
    query,
    options,
  )
}
